<template>
  <v-card class="bordered-card">
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Email Settings
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="px-4">
      <v-form>
        <v-layout
          row
          wrap>
          <v-flex
            xs12>
            <v-select
              v-model="requestEmailReceivers"
              :items="adminUsers"
              label="Request Email Receivers"
              item-avatar="avatar"
              item-text="fullName"
              item-value="uid"
              multiple
              autocomplete
              deletable-chips
              clearable
              chips/>
          </v-flex>
          <v-flex
            xs12>
            <v-select
              v-model="companySubmissionEmailReceivers"
              :items="adminUsers"
              label="Company Submission Email Receivers"
              item-avatar="avatar"
              item-text="fullName"
              item-value="uid"
              multiple
              autocomplete
              deletable-chips
              clearable
              chips/>
          </v-flex>
          <v-flex>
            <v-btn
              :disabled="saving"
              :loading="saving"
              color="primary"
              class="ma-0"
              @click="saveEmailReceivers">
              Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <!-- <v-snackbar
      :timeout="3000"
      :success="updateProcess"
      :error="status === 'error'"
      v-model="updateProcess"
    >{{ process }}
    </v-snackbar> -->
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      requestEmailReceivers: [],
      companySubmissionEmailReceivers: [],
      saving: false
    }
  },
  mounted() {
    this.$store.dispatch('loadUsers')
  },
  computed: {
    adminUsers () {
      const users = this.$store.getters.fetchUsers
      const adminUsers = users
        .filter(user => Number(user.role) === 1)
        .map(user => {
          return {
            uid: user.uid,
            fullName: `${user.firstname} ${user.lastname}`,
            avatar: user.avatar.indexOf('https') >= 0 ? user.avatar : `${window.location.host}/${user.avatar}`
          }
        })
      return adminUsers
    }
  },
  mounted () {
    this.getEmailReceivers()
  },
  methods: {
    async getEmailReceivers () {
      try {
        const snapshot = await this.$firebase
          .database()
          .ref('email_receivers')
          .once('value')
        const receivers = snapshot.val() || {}
        this.requestEmailReceivers = receivers.request || []
        this.companySubmissionEmailReceivers = receivers.companySubmission || []
      } catch (err) {
        let snackbar = {
          active: true,
          text: 'An error occured while getting the email receivers.'
        }
        this.$store.dispatch('triggerSnackbar', snackbar)
      }
    },
    async saveEmailReceivers () {
      try {
        this.saving = true
        const payload = {
          request: this.requestEmailReceivers,
          companySubmission: this.companySubmissionEmailReceivers
        }
        await this.$firebase
          .database()
          .ref('email_receivers')
          .set(payload)
        this.saving = false
      } catch (err) {
        this.saving = false
        let snackbar = {
          active: true,
          text: 'An error occured while saving the email receivers.'
        }
        this.$store.dispatch('triggerSnackbar', snackbar)
      }
    }
  }
}
</script>

<style>
.input-group--select {
  margin-top: 0 !important;
}
</style>


// WEBPACK FOOTER //
// email-settings.vue?7605cf79